import { Injectable, computed, signal } from '@angular/core';
import { ApplicationApiService } from '../services/application-api.service';
import { BehaviorSubject, Subscription, timer } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
    providedIn: 'root',
})
export class FeatureService {
    private readonly _refreshTimer = 60000;
    private featuresSubscription: Subscription = new Subscription();

    // Signals for state
    readonly featuresList = signal<{ name: string; enabled: boolean }[]>([]);
    readonly initialized = signal(false);

    // Observable streams for backward compatibility
    readonly featuresList$ = toObservable(this.featuresList);
    readonly initialized$ = toObservable(this.initialized);

    constructor(private _featuresClient: ApplicationApiService) {
    }

    /**
     * Check if a feature is enabled using signal
     */
    featureEnabled(featureName: string): boolean {
        const list = this.featuresList();
        return list.some(f => f.name && f.name.toLowerCase() === featureName.toLowerCase() && f.enabled === true);
    }

    /**
     * Create a computed signal for a specific feature
     */
    isFeatureEnabled(featureName: string) {
        return computed(() => {
            const list = this.featuresList();
            return list.some(f => f.name && f.name.toLowerCase() === featureName.toLowerCase() && f.enabled === true);
        });
    }

    initFeatureManagement(): void {
        const timer$ = timer(0, this._refreshTimer).pipe(tap(_ => {
            console.log('Feature Timer Called');
        }));

        this.featuresSubscription = timer$
            .pipe(switchMap(_ => this._featuresClient.apiFeatures()))
            .pipe(tap((features: { [key: string]: boolean }) => {
                this.featuresList.set(Object.entries(features).map(([name, enabled]) => ({ name, enabled })));
                this.initialized.set(true);
            })).subscribe();
    }
}
